module.exports = __webpack_public_path__ + "img/summary-1.a5b01ea6.svg";